import React, { Component } from 'react';
import { Layout, Card } from 'antd';
import { Footer } from '../../common/footer/footer'
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import ResetPasswordForm from "./form";
import './reset_password.css';
import Spinner from '../../spinner/spinner';
import { validateToken } from "./mutations/validateToken";
import InvalidResetPasswordLink from "./invalid_link";
import { SiteLogo } from '../../common/siteLogo/siteLogo'

const { Content } = Layout;

class ResetPasswordPage extends Component {
  static propTypes = {
    mutate: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      email: null
    };
  }

  get mutationParams() {
    return {
      variables: {
        input: {
          token: this.props.match.params.token
        }
      }
    };
  }

  async validateToken() {
    try {
      this.setState({ loading: true });
      const { data } =  await this.props.mutate(this.mutationParams);
      this.setState({ email: data.validateResetPasswordToken.email })
    } catch (response) {
      this.setState({ email: null });
    } finally {
      this.setState({ loading: false });
    }
  }

  componentWillMount() {
    this.validateToken();
  }

  renderElement() {
    if (this.state.email) {
      return <ResetPasswordForm email={ this.state.email }
                                token={ this.props.match.params.token } />;
    } else {
      return <InvalidResetPasswordLink/>;
    }
  }

  render() {
    if (this.state.loading) {
      return <Spinner />
    } else {
      return (
        <Layout className="reset-password-page reset-password-page__layout">
          <Content className="reset-password-page__content">
            <SiteLogo/>
            <Card className="reset-password-page__content-card">
              { this.renderElement() }
            </Card>
          </Content>
          <Footer className="footer-transparent"/>
        </Layout>
      );
    }
  }
}

export default graphql(validateToken)(ResetPasswordPage);


// WEBPACK FOOTER //
// ./src/components/pages/reset_password/reset_password.js